import React, { useState, useEffect, Fragment } from "react"
import axios from "axios"
import Moment from "react-moment"
import "moment-timezone"
import "../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css"
import "semantic-ui-css/semantic.min.css"
import { Pagination } from "semantic-ui-react"
import "../../assets/css/paginationlist.css"
import DateTime from "@nateradebaugh/react-datetime"
import "@nateradebaugh/react-datetime/css/react-datetime.css"
import * as moment from "moment"
import "moment/locale/th"
import { checkPermission } from "../../helper/functions"
import User from "../../libs/admin"
import Spinner from "react-bootstrap/Spinner"
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table"
// import ModalExport from "./ModalExport"

const statusMapping = {
	success: "ชำระเงินสำเร็จ",
	failed: "ชำระเงินไม่สำเร็จ",
	waiting: "รอการชำระเงิน",
	expired: "หมดเวลาการชำระเงิน",
}
const statusOptions = [
	{ value: "all", label: "รายการทั้งหมด" },
	{ value: "success", label: "ชำระเงินสำเร็จ" },
	{ value: "waiting", label: "รอการชำระเงิน" },
	{ value: "expired", label: "หมดเวลาชำระเงิน" },
	{ value: "failed", label: "ชำระเงินไม่สำเร็จ" },
]

const EverpinkDashboard = (props) => {
	const user = User.getCookieData()
	const [createDateGte, setCreateDateGte] = useState("")
	const [createDateLt, setCreateDateLt] = useState("")
	const [plan, setPlan] = useState()
	const [filter, setFilter] = useState({
		search: "",
		status: "all",
		businessType: "all",
		packageName: "all",
	})

	const [data, setData] = useState([])
	const [activePage, setActivePage] = useState(1)
	const [allPage, setAllPage] = useState("")
	const [totalCount, setTotalCount] = useState(0)
	const [isLoading, setIsLoading] = useState(false)
	const [modalExport, setModalExport] = useState(false)
	const [skus, setSkus] = useState([])

	const LinkInvoicePDF = (cell, row) => {
		if (row?.["PDF Invoice"] && row["PDF Invoice"] !== "-") {
			return (
				<a href={row["PDF Invoice"]} target="_blank" rel="noopener noreferrer">
					View PDF
				</a>
			)
		}
		return "-"
	}

	const getDateFormatterAdd7 = (cell) => {
		if (!cell || cell === "-") return "-"
		return (
			<div>
				<Moment format="YYYY-MM-DD H:mm:ss">{cell}</Moment> +0700
			</div>
		)
	}

	const getAddressFormatter = (cell) => {
		if (!cell || cell === "-") return "-"
		return <div style={{ whiteSpace: "normal", overflowWrap: "anywhere", wordBreak: "break-word" }}>{cell}</div>
	}

	const handleSelectChange = (key, value) => {
		const _filter = { ...filter }
		setFilter({ ..._filter, [key]: value })
	}

	const carlendarcreatedateLt = (date) => {
		const d1 = new Date(date)
		const d2 = new Date(createDateGte)
		if (d1 < d2) {
			setCreateDateLt(new Date())
		} else {
			setCreateDateLt(date)
		}
	}
	const carlendarcreatedateGte = (date) => {
		const d1 = new Date(date)
		const d2 = new Date(createDateLt)
		if (d1 > d2) {
			setCreateDateGte(new Date())
		} else {
			setCreateDateGte(date)
		}
	}

	const getCustomerTransaction = async (e, pageInfo) => {
		const checked = checkPermission(user.permission, ["everpink_customer_transaction_view"], "or")

		if (!checked) {
			props.history.push("/")
		}

		if (pageInfo?.activePage) {
			setActivePage(pageInfo.activePage)
		}
		setIsLoading(true)

		try {
			const { data } = await axios.get(`${process.env.REACT_APP_API_ROOT}/shopping/everpink/admin/transaction`, {
				params: {
					...filter,
					createDateGte,
					createDateLt,
					page: Number(pageInfo?.activePage ? pageInfo.activePage : activePage),
				},
				withCredentials: true,
			})
			if (!data?.data?.items || data?.data?.items?.length === 0) {
				resetData()
			} else {
				setTotalCount(data.data.count)
				setAllPage(data.data.totalPage)
				setActivePage(data.data.currentPage)
				setData(data.data.items)
			}
		} catch (error) {
			resetData()
			console.error("Error fetching customer transaction:", error)
		}
		setIsLoading(false)
	}

	const resetData = () => {
		setData([])
		setTotalCount(0)
		setAllPage(0)
		setActivePage(1)
	}

	const fetchSkus = async () => {
		try {
			const { data } = await axios.get(`${process.env.REACT_APP_API_ROOT}/shopping/everpink/admin/products/skus`, {
				withCredentials: true,
			})
			if (data?.data?.skus) {
				setSkus(data.data.skus)
			}
		} catch (error) {
			console.error("Error fetching SKUs:", error)
		}
	}

	const exportCSV = async () => {
		try {
			const res = await axios.get(`${process.env.REACT_APP_API_ROOT}/shopping/everpink/admin/transaction/export`, {
				withCredentials: true,
				params: { ...filter, createDateGte, createDateLt },
			})

			const url = window.URL.createObjectURL(new Blob([res.data], { type: "text/csv" }))
			const link = document.createElement("a")
			link.href = url
			link.download = "Everpink_Subscription.csv"
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
			link.remove()
			window.URL.revokeObjectURL(url)
		} catch (error) {
			console.error("Error exporting CSV:", error)
		}
	}

	const exportInvoiceZip = async () => {
		const res = await axios.get(`${process.env.REACT_APP_API_ROOT}/shopping/everpink/admin/invoice/export`, {
			withCredentials: true,
			params: { ...filter, createDateGte, createDateLt },
		})
		if (res.status === 200) {
			// alert("")
			// ระบบกำลังดำเนินการดาวน์โหลด
			// หากดำเนินการเรียบร้อยแล้ว ท่านจะได้รับลิงก์สำหรับดาวน์โหลดใบกำกับภาษีทางอีเมล
			alert("ระบบกำลังดำเนินการดาวน์โหลด\nหากดำเนินการเรียบร้อยแล้ว ท่านจะได้รับลิงก์สำหรับดาวน์โหลดใบกำกับภาษีทางอีเมล")
		}
	}

	useEffect(() => {
		fetchSkus()
		getCustomerTransaction()
	}, [])

	// Generate dynamic SKU columns
	const skuColumns = skus.map((sku) => ({
		key: sku,
		label: sku,
		width: 80,
	}))

	const columns = [
		{
			key: "Transaction ID",
			label: "Transaction ID",
			width: 200,
			isKey: true,
			format: (cell) => cell || "-",
		},
		{
			key: "Invoice No.",
			label: "Invoice No.",
			width: 150,
			format: (cell) => cell || "-",
		},
		{ key: "ชื่อ-นามสกุล", label: "ชื่อ-นามสกุล", width: 200, dataAlign: "left" },
		{
			key: "ที่อยู่",
			label: "ที่อยู่",
			width: 250,
			dataAlign: "left",
			format: getAddressFormatter,
			tdStyle: { whiteSpace: "normal", overflowWrap: "anywhere", wordBreak: "break-word" },
			thStyle: { whiteSpace: "normal" },
		},
		{ key: "เบอร์โทรศัพท์", label: "เบอร์โทร", width: 100 },
		...skuColumns,
		{ key: "Package Price", label: "ราคารวม", width: 100 },
		{ key: "Price/Unit -  VAT7%", label: "Price/Unit - VAT7%\nราคาต้นทุน", width: 150 },
		{ key: "Vatจากราคาต้นทุน", label: "Vat จากราคาต้นทุน\n7%", width: 150 },
		{ key: "Package Price", label: "ราคาซื้อ", width: 100 },
		{
			key: "Transaction fee (If Promptpay)",
			label: "Transaction fee\n(If Promptpay)\n1.20%",
			width: 125,
		},
		{
			key: "Transaction fee (If Credit card)",
			label: "Transaction fee\n(If Credit card)\n2.50%",
			width: 125,
		},

		{
			key: "Vat",
			label: "Vat\n7%",
			width: 75,
		},
		{
			key: "Total Omise fee",
			label: "Total Omise fee",
			width: 150,
		},
		{
			key: "Net Revenue",
			label: "Net Revenue\nราคาซื้อ - Total omise",
			width: 175,
		},
		{
			key: "สถานะการชำระเงิน",
			label: "สถานะการชำระเงิน",
			width: 150,
			format: (cell) => statusMapping[cell],
		},
		{
			key: "วันที่สร้างคำสั่งซื้อ",
			label: "วันที่สร้างคำสั่งซื้อ",
			width: 200,
			format: (cell) => getDateFormatterAdd7(cell),
		},
		{
			key: "วันที่ชำระเงินสำเร็จ",
			label: "วันที่ชำระเงิน",
			width: 200,
			format: (cell) => getDateFormatterAdd7(cell),
		},
		{
			key: "PDF Invoice",
			label: "PDF Invoice",
			format: LinkInvoicePDF,
			width: 100,
		},
	]
	return (
		<>
			<div className="card shadow mb-4">
				<div className="card-header py-3">
					<h6 className="m-0 font-weight-bold text-primary">รายชื่อสมาชิก</h6>
				</div>
				<br />
				<div className="card-body">
					<div className="container d-flex">
						<div className="row col-8">
							<div className="input-group md-form form-sm form-2 pl-0">
								<input
									className="form-control my-0 py-1 lime-border w-100"
									type="text"
									placeholder="ค้นหา Transaction ID, เบอร์โทร, ชื่อ-นามสกุล"
									aria-label="Search"
									value={filter?.search}
									onChange={(e) => setFilter({ ...filter, search: e.target.value })}
								/>
							</div>
						</div>
						<button className="btn btn-success btn-icon-split" onClick={() => getCustomerTransaction()}>
							<span className="icon text-white-50">
								<i className="fas fa-search"></i>
							</span>
							<span className="text">ค้นหาข้อมูล</span>
						</button>
					</div>

					<div class="container">
						<div class="card card-body" id="collapseExample">
							<div className="row">
								<div className="col-3">Create Date From</div>
								<div className="col-3">Create Date To</div>
							</div>
							<div className="row">
								<div className="col-3">
									<div className="row">
										<div className="col-12">
											<DateTime
												className="w-100"
												style={{ borderColor: "#ccc" }}
												dateFormat="YYYY-MM-DD"
												timeFormat={false}
												defaultValue={createDateGte}
												onChange={(date) => {
													carlendarcreatedateGte(moment(date).format("YYYY-MM-DD"))
												}}
											/>
										</div>
									</div>
								</div>
								<div className="col-3">
									<div className="row">
										<div className="col-12">
											<DateTime
												className="w-100"
												style={{ width: "100%", borderColor: "#ccc" }}
												dateFormat="YYYY-MM-DD"
												timeFormat={false}
												defaultValue={createDateLt}
												onChange={(date) => {
													const dateFormat = moment(date).set({ hour: 23, minute: 59, second: 59 }).format("YYYY-MM-DD HH:mm:ss")
													carlendarcreatedateLt(dateFormat)
												}}
											/>
										</div>
									</div>
								</div>
							</div>
							<div className="row">
								{/* <div className="col-3">Business Type</div> */}
								{/* <div className="col-3">Package Name</div> */}
								<div className="col-3">Status</div>
							</div>
							<div className="row">
								{/* <div className="col-3">
									<div className="row">
										<div class="col-12">
											<div class="input-group">
												<select class="custom-select" id="inputGroupSelect02" onChange={(e) => handleSelectChange("businessType", e.target.value)} disabled>
													{businessTypeOptions.map((option) => (
														<option key={option.value} value={option.value}>
															{option.label}
														</option>
													))}
												</select>
											</div>
										</div>
									</div>
								</div> */}
								{/* <div className="col-3">
									<div className="row">
										<div class="col-12">
											<div class="input-group">
												<select class="custom-select" id="inputGroupSelect03" onChange={(e) => handleSelectChange("packageName", e.target.value)}>
													{plan &&
														plan.map((option) => (
															<option key={option.value} value={option.value}>
																{option.label}
															</option>
														))}
												</select>
											</div>
										</div>
									</div>
								</div> */}
								<div className="col-3">
									<div className="row">
										<div class="col-12">
											<div class="input-group">
												<select class="custom-select" id="inputGroupSelect04" onChange={(e) => handleSelectChange("status", e.target.value)}>
													{statusOptions.map((option) => (
														<option key={option.value} value={option.value}>
															{option.label}
														</option>
													))}
												</select>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<br />
					<div className="row" style={{ marginBottom: "8px" }}>
						<div className="col-10">
							<>
								{isLoading ? (
									<Fragment>
										<button className="btn btn-secondary" style={{ width: "120px", height: "41px" }}>
											<Spinner animation="border" role="status" variant="success">
												<span className="sr-only">Loading...</span>
											</Spinner>
										</button>
									</Fragment>
								) : (
									<>
										<button className="btn btn-secondary" onClick={exportCSV} style={{ minWidth: "120px", height: "41px " }}>
											Export to CSV
										</button>
										<button className="btn btn-secondary" onClick={exportInvoiceZip} style={{ minWidth: "120px", height: "41px ", marginLeft: "8px" }}>
											Download ใบกำกับภาษี
										</button>
										&nbsp;
									</>
								)}
							</>
						</div>
						<div class="col-2">จำนวนข้อมูล {totalCount}</div>
					</div>
					<BootstrapTable data={data} className="table table-striped">
						{columns.map((col) => (
							<TableHeaderColumn
								key={col.key}
								dataField={col.key}
								width={col.width}
								isKey={col.isKey}
								dataFormat={col.format}
								dataAlign={col.dataAlign || "center"}
								tdStyle={col.tdStyle}
								thStyle={col.thStyle}
								columnClassName={col.columnClassName}
							>
								{col.label.split("\n").map((line, i) => (
									<React.Fragment key={i}>
										{line}
										<br />
									</React.Fragment>
								))}
							</TableHeaderColumn>
						))}
					</BootstrapTable>
					{data.length !== 0 && <Pagination activePage={activePage} onPageChange={getCustomerTransaction} totalPages={allPage} ellipsisItem={null} />}
				</div>
			</div>
			{/* {modalExport && <ModalExport formSearchQuery={formSearchQuery} setModalExport={setModalExport} />} */}
		</>
	)
}
export default EverpinkDashboard
